import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { LogoutService } from './services/auth/logout.service';
import { RoutePageAccessPolicy } from './services/auth/route-page-access.policy';

@Injectable({
  providedIn: 'root'
})
export class LegacyPageAccessGuard implements CanActivate {
  constructor(
    private logoutService: LogoutService,
    private routePageAccessPolicy: RoutePageAccessPolicy
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    const resolution = this.routePageAccessPolicy.resolveShellPagePath({
      url: state.url,
      route
    });

    if (resolution.kind !== 'legacy' || !resolution.pagePath) {
      return of(true);
    }

    return this.routePageAccessPolicy.checkAccess(resolution.pagePath).pipe(
      map((result) => {
        if (result === 'auth-required') {
          this.logoutService.setReturnUrl(state.url);
        }
        return this.routePageAccessPolicy.mapLegacyGuardResult(result);
      }),
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          this.logoutService.setReturnUrl(state.url);
        }
        return throwError(() => error);
      })
    );
  }
}
